import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler, // Importar o Filler para preenchimento de área
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler // Registrar o Filler
);

const CrescimentoPlataformaChart = ({ data, options }) => {
  return <Line data={data} options={options} />;
};

export default CrescimentoPlataformaChart;